exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scores-container[data-v-38168230]{width:100%}.grade_level_container[data-v-38168230]{display:none}.strike[data-v-38168230]{display:block;text-align:center;overflow:hidden;white-space:nowrap;font-size:20px}.strike>span[data-v-38168230]{position:relative;display:inline-block}.strike>span[data-v-38168230]:after,.strike>span[data-v-38168230]:before{content:\"\";position:absolute;top:50%;width:9999px;border-top:1px dotted #c9c9c9}.strike>span[data-v-38168230]:before{right:100%;margin-right:15px}.strike>span[data-v-38168230]:after{left:100%;margin-left:15px}", ""]);

// exports
